export var EQuotedPriceType;
(function (EQuotedPriceType) {
    EQuotedPriceType[EQuotedPriceType["Day"] = 1] = "Day";
    EQuotedPriceType[EQuotedPriceType["Common"] = 2] = "Common";
})(EQuotedPriceType || (EQuotedPriceType = {}));
export default EQuotedPriceType;
